import React, { ReactElement } from 'react';
import { makeStyles } from '@mui/styles';
import { colors, theme } from 'src/theme';
import { IconButton, TableBody, TableCell, TableRow } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import DownloadIcon from '@mui/icons-material/FileDownloadOutlined';
import PreviewIcon from '@mui/icons-material/Preview';
import dayjs from 'dayjs';
import { RoutineDetailsDocumentTableType } from 'src/types/routine.types';
import { ToolTip } from 'src/components/shared/tooltip/tooltip';

const testid = 'routine-doc-table';

const color = colors();
const themes = theme().typography;
export const RoutineDocTable = ({
	type,
	documents,
	allowEdit,
	handleDownload,
	setDocName,
	getSasToken,
	setDeleteDialog,
	setDocType,
	handleFileClick,
}: RoutineDetailsDocumentTableType): ReactElement => {
	const classes = useStyles();
	const filteredDocs = documents.filter(
		(row) => row.documentType.toLowerCase() === type.toLowerCase() && row.isDelete !== true
	);

	return (
		<TableBody>
			{filteredDocs.map((row, i) => (
				<TableRow
					hover
					key={`${testid}-${type}-${i}`}
					data-testid={`${testid}-${type}-${i}`}
					className={classes.tableRow}
				>
					<TableCell>
						{i === 0
							? type === 'Required'
								? 'Required document'
								: type === 'Supporting'
								? 'Supporting document'
								: 'Material specific document'
							: ''}
					</TableCell>{' '}
					<TableCell>{row.documentName}</TableCell>
					<TableCell>{dayjs(row.documentUploadedDate).format('DD MMM, YYYY')}</TableCell>
					<TableCell>
						<>
							<ToolTip tooltipText="Download">
								<span>
									<IconButton id={`download-${type}-doc`} onClick={() => handleDownload(row)}>
										<DownloadIcon className={classes.iconButton} />
									</IconButton>
								</span>
							</ToolTip>
							<ToolTip tooltipText="View">
								<span>
									<IconButton
										id={`view-${type}-doc`}
										onClick={() => {
											setDocName(row.documentName);
											getSasToken();
										}}
									>
										<PreviewIcon className={classes.iconButton} />
									</IconButton>
								</span>
							</ToolTip>
							{allowEdit && (
								<ToolTip tooltipText="Delete">
									<span>
										<IconButton
											id={`delete-${type}-doc`}
											onClick={() => {
												setDocName(row.documentName);
												setDeleteDialog(true);
											}}
										>
											<DeleteIcon className={classes.iconButton} />
										</IconButton>
									</span>
								</ToolTip>
							)}
						</>
					</TableCell>
					{allowEdit && (
						<TableCell>
							{i === 0 && (
								<div
									className={classes.newDoc}
									onClick={() => {
										setDocType(type);
										handleFileClick();
									}}
								>
									<AddIcon id={`add-${type}-doc`} /> Add {type} document
								</div>
							)}
						</TableCell>
					)}
				</TableRow>
			))}
			{allowEdit && (documents.length === 0 || filteredDocs.length === 0) && (
				<TableRow key={`${testid}-${type}-docs`} data-testid={`${testid}-${type}-docs`} className={classes.tableRow}>
					<TableCell colSpan={5}>
						<div
							className={classes.newDoc}
							onClick={() => {
								setDocType(type);
								handleFileClick();
							}}
						>
							<AddIcon id={`add-${type}-doc`} /> Add {type} document
						</div>
					</TableCell>
				</TableRow>
			)}
		</TableBody>
	);
};

const useStyles = makeStyles(() => ({
	newDoc: {
		display: 'flex',
		width: '100%',
		color: color.signal.info,
		cursor: 'pointer',
		alignItems: 'center',
	},
	iconButton: {
		width: '16px !important',
		height: '16px !important',
		color: color.primary[90],
	},
	tableRow: {
		'& .MuiTableCell-root': {
			...themes.bodySmall,
			padding: '5px 9px',
			border: 0,
		},
	},
}));
